const STATUS_400 = 400;
const STATUS_404 = 404;
const STATUS_500 = 500;

export { STATUS_400, STATUS_404, STATUS_500 };
